<div *ngIf="show" class="loading-container no-text-select">
    <div class="loading-container-cont wow fadeInUp" data-wow-duration="1s">
        <div class="pre-loading">
            <p class="loading">Conectando con el medio de pago<span>.</span><span>.</span><span>.</span></p>
        </div>
    </div>
</div>